import React, { useState, useEffect, useRef } from 'react';
import {
    X,
    Plus,
    Save,
    User,
    Building,
    Phone,
    Mail,
    MapPin,
    ChevronDown,
    ChevronUp,
    Search,
    ChevronLeft,
    Globe,
    Layers,
    Type,
    FileText,
    Calendar,
    Tag,
    MessageSquare,
    Info,
    Filter,
    Users,
    Camera,
    Trash2,
    CheckCircle
} from 'lucide-react';
import API_ENDPOINTS from '../../../../config/apiEndpoints';
import { getSession, getToken } from '../../../../getSession';
import Loader from '../../../../components/Loader/Loader';
import Alert from '../../../../common/Alerts/Alert';
import { bindSourceMediumCampaign } from '../../../../utils/lead';

const AddEnquiryForm = ({ onBack, onSuccess, saveEditToken }) => {
    const [loading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [alertConfig, setAlertConfig] = useState({
        show: false,
        type: 'success',
        title: 'Success',
        message: '',
        onConfirm: null
    });

    const [editForm, setEditForm] = useState({
        PersonName: '',
        Company: '',
        Country: '',
        State: '',
        City: '',
        Source: '',
        Medium: '',
        Campaign: '',
        ResiAddress: '',
        OfficeAddress: '',
        Remarks: '',
        PinCode: '0',
        EnquiryTags: ''
    });

    // Multiple mobile/email states
    const [mobiles, setMobiles] = useState([
        { number: '', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', showDropdown: false }
    ]);
    const [emails, setEmails] = useState(['']);

    const [isAdvanced, setIsAdvanced] = useState(false);
    const [addToLead, setAddToLead] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [usersList, setUsersList] = useState([]);

    const [customFieldsData, setCustomFieldsData] = useState({});
    const [customFieldsList, setCustomFieldsList] = useState([]);

    const [countries, setCountries] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);
    const [isLocationLoading, setIsLocationLoading] = useState(false);

    // Avatar states
    const [profileFile, setProfileFile] = useState(null);
    const [profilePreview, setProfilePreview] = useState(null);
    const avatarInputRef = useRef(null);
    const tagInputRef = useRef(null);
    const [tagInput, setTagInput] = useState('');

    // Course Dependency Logic
    const [courseDependency, setCourseDependency] = useState([
        { ParentValue: "Diploma", ChildValue: ["N/A"] },
        { ParentValue: "Gratuate", ChildValue: ["B. Arch", "B. Com", "B. Ed", "B. Tech / B.E.", "B.A", "B.B.A", "B.C.A", "B.D.S", "B.H.M", "B.H.M.S", "B.Pharma", "B.Sc", "L.L.B", "M.B.B.S", "Other"] },
        { ParentValue: "Post Gratuate", ChildValue: ["CS", "ICWA", "L.L.M", "M. Arch", "M. Com", "M. Ed", "M. Tech / M.E.", "M.A", "M.B.A", "M.C.A", "M.D.S", "M.H.M", "M.Pharma", "M.Sc", "Other", "PGDBA"] }
    ]);

    const [courseOptions, setCourseOptions] = useState([]);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [mediumOptions, setMediumOptions] = useState([]);
    const [campaignOptions, setCampaignOptions] = useState([]);

    const [dynamicCountries, setDynamicCountries] = useState([]);
    const [dialSearchTerm, setDialSearchTerm] = useState('');
    const dialCodeRef = useRef(null);

    // Field addition helpers
    const addMobileField = () => {
        if (mobiles.length < 3) {
            setMobiles([...mobiles, { number: '', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', showDropdown: false }]);
        }
    };

    const addEmailField = () => {
        if (emails.length < 3) {
            setEmails([...emails, '']);
        }
    };

    const updateMobile = (index, key, value) => {
        const newMobiles = [...mobiles];
        newMobiles[index][key] = value;
        setMobiles(newMobiles);
    };

    const updateEmail = (index, value) => {
        const newEmails = [...emails];
        newEmails[index] = value;
        setEmails(newEmails);
    };

    const removeMobileField = (index) => {
        if (mobiles.length > 1 && index > 0) {
            setMobiles(mobiles.filter((_, i) => i !== index));
        }
    };

    const removeEmailField = (index) => {
        if (emails.length > 1 && index > 0) {
            setEmails(emails.filter((_, i) => i !== index));
        }
    };

    const toggleMobileDropdown = (index, state) => {
        const newMobiles = [...mobiles];
        // Close all others first
        newMobiles.forEach((m, i) => { if (i !== index) m.showDropdown = false; });
        newMobiles[index].showDropdown = state !== undefined ? state : !newMobiles[index].showDropdown;
        setMobiles(newMobiles);
    };

    const UNIVERSAL_TOKEN = '-2295521862261168';
    const getActiveToken = () => {
        try {
            const urlStr = localStorage.getItem('URL') || '';
            const otpMatch = urlStr.match(/OTP=([^&]+)/i);
            if (otpMatch && otpMatch[1]) {
                return otpMatch[1];
            }
            const token = getToken();
            if (token && token !== '-1') return token;
        } catch (e) { }
        return saveEditToken || UNIVERSAL_TOKEN;
    };
    const TOKEN = getActiveToken();
    const WCF_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || '').replace(/\/$/, '');
    const SERVICE_AZURE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const LOCAL_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');


    const Get_country = `${LOCAL_BASE_URL}/Common/GetCountryList`;
    const Get_State = `${LOCAL_BASE_URL}/Common/GetStateListByCountryId`;
    const Get_city_By_State = `${LOCAL_BASE_URL}/Common/GetCityListByStateId`;

    const Custome_Data_More = `${SERVICE_AZURE_URL}${API_ENDPOINTS.ENQUIRIES.CUSTOME_DATA_MORE}`;
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const Get_Course = `${NEWV3_BASE_URL}${API_ENDPOINTS.FOLLOWUPS.GET_CENTER_OF_EDUCATION_EDIT}`;
    const Collabrator = `${SERVICE_AZURE_URL}${API_ENDPOINTS.APPOINTMENTS.GET_USERLIST_PHYSICALAPP_VIEW}`;
    const Save_Enqiury = `${LOCAL_BASE_URL}${API_ENDPOINTS.ENQUIRIES.ADD_ENQUIRY}`;
    const Save_Enqiury_With_Location = `${LOCAL_BASE_URL}${API_ENDPOINTS.ENQUIRIES.SAVE_ENQUIRY_WITH_LOCATION}`;
    const Get_Custom_Fields = `${LOCAL_BASE_URL}${API_ENDPOINTS.ENQUIRIES.GET_CUSTOM_FIELDS}`;

    const MAPPED_CUSTOM_FIELDS = [
        { label: 'Amount', key: '8844', type: 't' },
        { label: 'Service', key: '8845', type: 't' },
        { label: 'Charges', key: '8846', type: 't' },
        { label: 'Bank Name', key: '8847', type: 't' },
        { label: 'Bill Amount', key: '8848', type: 't' },
        { label: 'Due Date', key: '8849', type: 'd' },
        { label: 'Card Status', key: '8850', type: 't' },
        { label: 'Card Type', key: '8851', type: 't' },
        { label: 'Bank Name 2', key: '8868', type: 't' },
        { label: 'Bill Amount 2', key: '8869', type: 't' },
        { label: 'Due Date 2', key: '8870', type: 'd' },
        { label: 'Card Status 2', key: '8871', type: 't' },
        { label: 'Card Type 2', key: '8872', type: 't' },
        { label: 'Bank Name 3', key: '8873', type: 't' },
        { label: 'Bill Amount 3', key: '8874', type: 't' },
        { label: 'Due Date 3', key: '8875', type: 'd' },
        { label: 'Card Status 3', key: '8876', type: 't' },
        { label: 'Card Type 3', key: '8877', type: 't' },
        { label: 'DOB', key: '1237', type: 'd' },
        { label: 'Study Level', key: '5291', type: 'dropdown' },
        { label: 'Course', key: '5292', type: 'dropdown' },
        { label: 'Centre For Education', key: '5293', type: 'dropdown' },
        { label: 'Company Incorporation Date', key: '7580', type: 'd' },
        { label: 'MCA Registered City', key: '7581', type: 't' },
        { label: 'Equity Percentage', key: '7583', type: 't' },
        { label: 'Mandate Start Date', key: '7585', type: 'd' },
        { label: 'Mandate End Date', key: '7586', type: 'd' },
        { label: 'Project Name', key: '7620', type: 't' },
        { label: 'is_Adult', key: '7692', type: 'radio' },
        { label: 'Locate Our Office', key: '8153', type: 't' },
        { label: 'Pending Amount', key: '8580', type: 't' },
        { label: 'Warranty Valid Till', key: '8629', type: 'd' },
        { label: 'Warranty Start Date', key: '8630', type: 'd' },
        { label: 'Product', key: '8780', type: 't' },
        { label: 'Monthly EMI', key: '8899', type: 't' },
        { label: 'Demo Date', key: '8903', type: 'd' },
        { label: 'Official Address', key: '10365', type: 't' },
        { label: 'KW Requirement', key: '10545', type: 't' },
        { label: 'Gender', key: '10546', type: 'radio' },
        { label: 'Education', key: '11919', type: 'checkbox' },
        { label: 'Client ID', key: '2686', type: 't' },
        { label: 'NAME', key: '2503', type: 't' },
        { label: 'WhatsApp Response', key: '2796', type: 't' },
        { label: 'Response', key: '2795', type: 't' },
        { label: 'User Code', key: '6276', type: 't' },
        { label: 'OPE Preapproval', key: '7587', type: 't' },
        { label: 'Business Referral Mandate', key: '7588', type: 't' },
        { label: 'Addendum', key: '7589', type: 't' },
        { label: 'Test121', key: '8167', type: 't' },
        { label: 'Number of users', key: '8244', type: 't' },
        { label: 'RRTR', key: '8355', type: 't' },
        { label: 'dytdutdtjg', key: '8356', type: 't' },
        { label: 'Select Option', key: '8781', type: 't' },
        { label: 'DATE TIME', key: '8066', type: 'd' },
        { label: 'new test', key: '8994', type: 't' },
        { label: 'trest', key: '9302', type: 't' },
        { label: 'testing09099', key: '9513', type: 't' },
        { label: 'upload doc', key: '10056', type: 't' },
        { label: 'test', key: '10528', type: 't' },
        { label: 'naklikit', key: '8058', type: 't' },
        { label: 'Education diploma', key: '11921', type: 't' }
    ];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dial-code-selector') && !event.target.closest('.dial-code-dropdown')) {
                setMobiles(prev => prev.map(m => ({ ...m, showDropdown: false })));
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await Promise.all([
                fetchInitialOptions(),
                fetchDynamicCountries(),
                fetchFields(),
                fetchCourseOptions(),
                fetchUsersList()
            ]);
            setLoading(false);
        };
        init();
    }, []);

    const fetchInitialOptions = async () => {
        try {
            const { parentId, TokenId, userId } = getSession();
            const finalToken = TokenId || TOKEN;
            const payloadOptions = {
                Token: finalToken,
                Message: "",
                LoggedUserId: userId ?? 0,
                MAC_Address: "",
                IP_Address: "102.16.32.189",
                BroadcastName: ""
            };

            const [sourceList, mediumList, campaignList, countryRes] = await Promise.all([
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'SourceName', Parentid: Number(parentId || 0) } }),
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'MediumName', Parentid: Number(parentId || 0) } }),
                bindSourceMediumCampaign({ ...payloadOptions, Details: { Type: 'CampaignName', Parentid: Number(parentId || 0) } }),
                fetch(Get_country, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ Token: "-2295521862261168", Details: {} }) })
            ]);

            setSourceOptions(sourceList);
            setMediumOptions(mediumList);
            setCampaignOptions(campaignList);
            if (countryRes.ok) {
                const res = await countryRes.json();
                const raw = res.d || res.Details || [];
                setCountries(typeof raw === 'string' ? JSON.parse(raw) : raw);
            }
        } catch (error) { console.error("Error fetching options:", error); }
    };

    const fetchDynamicCountries = async () => {
        try {
            const response = await fetch('https://raw.githubusercontent.com/mledoze/countries/master/countries.json');
            const data = await response.json();
            const list = data.map(item => {
                const root = item.idd?.root || "";
                const suffix = item.idd?.suffixes ? item.idd.suffixes[0] : "";
                return {
                    name: item.name.common,
                    dialCode: root + suffix,
                    flag: item.flags?.png || `https://flagcdn.com/w320/${(item.cca2 || '').toLowerCase()}.png`,
                    code: item.cca2
                };
            }).filter(c => c.dialCode).sort((a, b) => a.name.localeCompare(b.name));
            setDynamicCountries(list.length > 0 ? list : getFallbackCountries());
        } catch (error) {
            console.error("Error fetching dynamic countries:", error);
            setDynamicCountries(getFallbackCountries());
        }
    };

    const getFallbackCountries = () => [
        { name: 'India', dialCode: '+91', flag: 'https://flagcdn.com/w320/in.png', code: 'IN' },
        { name: 'United States', dialCode: '+1', flag: 'https://flagcdn.com/w320/us.png', code: 'US' },
        { name: 'United Kingdom', dialCode: '+44', flag: 'https://flagcdn.com/w320/gb.png', code: 'GB' },
        { name: 'Australia', dialCode: '+61', flag: 'https://flagcdn.com/w320/au.png', code: 'AU' },
        { name: 'Canada', dialCode: '+1', flag: 'https://flagcdn.com/w320/ca.png', code: 'CA' },
        { name: 'Singapore', dialCode: '+65', flag: 'https://flagcdn.com/w320/sg.png', code: 'SG' },
        { name: 'United Arab Emirates', dialCode: '+971', flag: 'https://flagcdn.com/w320/ae.png', code: 'AE' }
    ];

    const fetchFields = async () => {
        try {
            const { parentId } = getSession();
            const resolvedParentId = parentId || localStorage.getItem('ParentID') || localStorage.getItem('userId') || '0';

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    ParentId: Number(resolvedParentId),
                    Status: "Active"
                }
            };

            const response = await fetch(Get_Custom_Fields, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            let apiFields = [];
            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1 && result.Details) {
                    apiFields = result.Details.filter(f => {
                        const isActiveField = f.isActive === true || f.IsActive === 'True' || String(f.IsActive).toLowerCase() === 'true' || f.IsActive === true;
                        return isActiveField; // Only Active
                    });
                }
            }

            const parsedApiFields = apiFields.map(f => {
                const fieldName = f.fieldname || f.FieldName || "";
                const fieldId = String(f.field_ID || f.FieldID || f.Id || "");
                const rawType = (f.datatype || f.DataType || "v").toLowerCase();
                const isMandatory = f.isMandatory === true || f.IsMandatory === 'True' || String(f.IsMandatory).toLowerCase() === 'true';
                const choices = f.choices || f.Choices || "";

                let type = 't';
                if (rawType === 'd' || rawType === 'date field') type = 'd';
                else if (rawType === 'ddl' || rawType === 'mddl' || rawType === 'dropdown field' || rawType === 'multiple select field') type = 'dropdown';
                else if (rawType === 'r' || rawType === 'radio field') type = 'radio';
                else if (rawType === 'c' || rawType === 'checkbox field') type = 'checkbox';

                return {
                    label: fieldName,
                    key: fieldId,
                    type: type,
                    isMandatory: isMandatory,
                    choices: choices
                };
            });

            // Merge with MAPPED_CUSTOM_FIELDS to preserve specialized types/labels if they exist in the API results
            const finalFields = parsedApiFields.map(af => {
                const hardcoded = MAPPED_CUSTOM_FIELDS.find(mf => String(mf.key) === String(af.key));
                return hardcoded ? { ...af, ...hardcoded } : af;
            });

            setCustomFieldsList(finalFields);
        } catch (error) {
            console.error("Error fetching custom fields:", error);
            // On error, fallback to empty or a safe subset of MAPPED_CUSTOM_FIELDS
            // But to avoid the error for the user, we strictly avoid adding fields that don't belong.
            setCustomFieldsList([]);
        }
    };

    const fetchCourseOptions = async () => {
        try {
            const { parentId } = getSession();
            const response = await fetch(Get_Course, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: "-2295521862261168",
                    Details: { leadno: 42957, parentid: Number(parentId) || 34594 }
                })
            });
            if (response.ok) {
                const data = await response.json();
                const rawList = data.Details?.[0] || data.d?.[0] || data.Details || data.d || [];
                const safeList = Array.isArray(rawList) ? rawList : (rawList ? [rawList] : []);
                setCourseOptions(safeList);
                const dependency = [];
                safeList.forEach(item => {
                    const existing = dependency.find(d => d.ParentValue === item.ParentValue);
                    if (existing) {
                        existing.ChildValue.push(item.ChildValue);
                    } else {
                        dependency.push({ ParentValue: item.ParentValue, ChildValue: [item.ChildValue] });
                    }
                });
                setCourseDependency(dependency);
            }
        } catch (error) { console.error("Error fetching course options:", error); }
    };

    const fetchUsersList = async () => {
        try {
            const { parentId } = getSession();
            const response = await fetch(Collabrator, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: TOKEN, Details: { UserId: Number(parentId) } })
            });
            if (response.ok) {
                const data = await response.json();
                const rawUsers = data.Details?.data || data.Details || data.d || data;
                let parsed = Array.isArray(rawUsers) ? rawUsers : [];
                if (typeof rawUsers === 'string') { try { parsed = JSON.parse(rawUsers); } catch (e) { } }
                setUsersList(Array.isArray(parsed) ? parsed : []);
            }
        } catch (error) { console.error("Error fetching users list:", error); }
    };

    const handleCountryChange = async (countryId) => {
        setEditForm({ ...editForm, Country: countryId, State: '', City: '' });
        setStatesList([]);
        setCitiesList([]);
        if (!countryId) return;
        setIsLocationLoading(true);
        try {
            const res = await fetch(Get_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(countryId, 10) || parseInt(countryId.replace(/\D/g, ''), 10) || countryId } })
            });
            if (res.ok) { const data = await res.json(); setStatesList(data.d || data.Details || []); }
        } catch (error) { console.error("Error fetching states:", error); }
        finally { setIsLocationLoading(false); }
    };

    const handleStateChange = async (stateId) => {
        setEditForm({ ...editForm, State: stateId, City: '' });
        setCitiesList([]);
        if (!stateId) return;
        setIsLocationLoading(true);
        try {
            const res = await fetch(Get_city_By_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(stateId, 10) || parseInt(stateId.replace(/\D/g, ''), 10) || stateId } })
            });
            if (res.ok) { const data = await res.json(); setCitiesList(data.d || data.Details || []); }
        } catch (error) { console.error("Error fetching cities:", error); }
        finally { setIsLocationLoading(false); }
    };

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validation: 1MB max as per user screenshot
        if (file.size > 1024 * 1024) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Error',
                message: 'Image size must be less than 1MB.'
            });
            return;
        }

        // Validation: Type
        const allowed = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif'];
        if (!allowed.includes(file.type)) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Error',
                message: 'Only JPG, PNG, BMP and GIF are allowed.'
            });
            return;
        }

        setProfileFile(file);
        setProfilePreview(URL.createObjectURL(file));
    };

    const removeAvatar = () => {
        setProfileFile(null);
        setProfilePreview(null);
        if (avatarInputRef.current) avatarInputRef.current.value = "";
    };

    const parseCustomField = (text) => {
        if (!text) return { value: '', label: '', type: '' };
        const parts = text.split('|');
        return { value: parts[0] || '', label: parts[1] || text, type: parts[2] || 't' };
    };

    const formatDateToBackend = (date) => {
        if (!date) return "";
        const d = new Date(date);
        if (isNaN(d.getTime())) return date;
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };

    const formatDateToBackendShort = (date) => {
        if (!date) return "";
        const d = new Date(date);
        if (isNaN(d.getTime())) return date;
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const renderCustomField = (item, idx) => {
        const val = customFieldsData[item.key] || '';
        const fieldId = String(item.key);
        const label = item.label;
        const type = item.type;

        const fieldWrapperStyle = { display: 'flex', alignItems: 'center', marginBottom: '12px' };
        const labelStyle = { width: '250px', fontSize: '13px', color: '#333', fontWeight: '600' };
        const inputWrapperStyle = { flex: 1 };
        const inputStyle = { width: '100%', padding: '6px 12px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none', fontSize: '13px' };

        // Specialized Rendering based on ID/Label
        if (fieldId === "5291") {
            const options = [...new Set(courseOptions.map(o => o.ParentValue))];
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label}</label>
                    <div style={inputWrapperStyle}>
                        <select
                            value={val}
                            onChange={(e) => {
                                const newVal = e.target.value;
                                setCustomFieldsData(prev => ({ ...prev, [fieldId]: newVal, ["5292"]: "" }));
                            }}
                            style={inputStyle}
                        >
                            <option value="">--Select Option--</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Gratuate">Gratuate</option>
                            <option value="Post Gratuate">Post Gratuate</option>
                            {options.map((opt, i) => !["Diploma", "Gratuate", "Post Gratuate"].includes(opt) && <option key={i} value={opt}>{opt}</option>)}
                        </select>
                    </div>
                </div>
            );
        }

        if (fieldId === "5292") {
            const studyLevelVal = customFieldsData["5291"] || "";
            const filteredCourses = courseDependency.find(d => d.ParentValue === studyLevelVal)?.ChildValue || [];
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label}</label>
                    <div style={inputWrapperStyle}>
                        <select
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            disabled={!studyLevelVal}
                            style={{ ...inputStyle, background: !studyLevelVal ? '#f9fafb' : '#fff' }}
                        >
                            <option value="">--Select Option--</option>
                            {filteredCourses.map((c, i) => <option key={i} value={c}>{c}</option>)}
                        </select>
                    </div>
                </div>
            );
        }

        if (fieldId === "5293") {
            const centers = ["Delhi", "Chennai", "Jaipur", "Ahmedabad", "Gurgaon", "Pune", "Other", "Kolkata", "Indore", "Raipur", "Chandigarh", "Mumbia", "Lucknow"];
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label}</label>
                    <div style={inputWrapperStyle}>
                        <select
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            style={inputStyle}
                        >
                            <option value="">--Select Option--</option>
                            {centers.map((c, i) => <option key={i} value={c}>{c}</option>)}
                        </select>
                    </div>
                </div>
            );
        }

        if (type === 'checkbox') {
            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label}{item.isMandatory && <span style={{ color: 'red' }}> *</span>}</label>
                    <div style={{ ...inputWrapperStyle }}>
                        <input
                            type="checkbox"
                            checked={!!val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.checked })}
                            style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: 'red' }}
                        />
                    </div>
                </div>
            );
        }

        if (fieldId === "7692" || fieldId === "10546" || fieldId === "7620" || type === 'radio') {
            let options = ["yes", "no", "don't wish to answer"];
            if (fieldId === "10546") options = ["Male", "Female"];

            // If field has its own choices from API, use them
            if (item.choices) {
                options = item.choices.split(',').map(o => o.trim()).filter(o => o);
            }

            return (
                <div key={idx} style={fieldWrapperStyle}>
                    <label style={labelStyle}>{label}{item.isMandatory && <span style={{ color: 'red' }}> *</span>}</label>
                    <div style={{ ...inputWrapperStyle, display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                        {options.map(opt => (
                            <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', cursor: 'pointer' }}>
                                <input
                                    type="radio"
                                    name={`radio_${fieldId}`}
                                    value={opt}
                                    checked={(val || '').toLowerCase() === opt.toLowerCase()}
                                    onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                                    style={{ accentColor: 'red' }}
                                />
                                {opt}
                            </label>
                        ))}
                    </div>
                </div>
            );
        }

        return (
            <div key={idx} style={fieldWrapperStyle}>
                <label style={labelStyle}>{label}{item.isMandatory && <span style={{ color: 'red' }}> *</span>}</label>
                <div style={inputWrapperStyle}>
                    {type === 'd' ? (
                        <input
                            type="date"
                            placeholder={`${label}`}
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            style={inputStyle}
                        />
                    ) : type === 'dropdown' ? (
                        <select
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            style={inputStyle}
                        >
                            <option value="">--Select Option--</option>
                            {(item.choices || "").split(',').map(o => o.trim()).filter(o => o).map((opt, i) => (
                                <option key={i} value={opt}>{opt}</option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type="text"
                            placeholder={`${label}`}
                            value={val}
                            onChange={(e) => setCustomFieldsData({ ...customFieldsData, [fieldId]: e.target.value })}
                            style={inputStyle}
                        />
                    )}
                </div>
            </div>
        );
    };

    const handleSave = async () => {
        if (!editForm.PersonName) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Required Field',
                message: 'Name is required.'
            });
            return;
        }
        if (!mobiles[0].number) {
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Required Field',
                message: 'Mobile 1 is required.'
            });
            return;
        }

        // Validate Mandatory Custom Fields
        for (const field of customFieldsList) {
            if (field.isMandatory) {
                const val = customFieldsData[field.key];
                if (!val || (typeof val === 'string' && val.trim() === '')) {
                    setAlertConfig({
                        show: true,
                        type: 'error',
                        title: 'Required Field',
                        message: `${field.label} is required.`
                    });
                    return;
                }
            }
        }
        setIsSaving(true);
        try {
            const session = getSession();

            // Aggressively capture IDs from localStorage or session
            const userId = localStorage.getItem('userId') || localStorage.getItem('kit_userId') || session.userId || 34594;
            const parentId = localStorage.getItem('ParentID') || localStorage.getItem('kit_parentId') || session.parentId || 34594;

            // Map custom fields to match backend { FieldId, FieldValue }
            const lstCustomField = customFieldsList.map(item => {
                let val = customFieldsData[item.key] || "";
                if (item.type === 'd' && val) val = formatDateToBackendShort(val);
                const valLower = String(val).toLowerCase();
                if (item.key === '7692' || item.key === '11919' || item.key === '10546') {
                    if (valLower === "yes" || valLower === "true" || valLower === "male") val = "1";
                    else if (valLower === "no" || valLower === "false" || valLower === "female") val = "0";
                }
                return {
                    FieldId: Number(item.key), // Ensure FieldId is numeric
                    FieldValue: String(val)
                };
            });

            // Get names from selected IDs for Source, Medium, Campaign, etc.
            // Lookup IDs if we have names in the state for Source, Medium, Campaign
            const getMappedId = (currentVal, options) => {
                const v = currentVal?.toString() || "";
                if (!v || v === "0") return "0";
                // If it looks like a numeric ID, return it directly
                if (/^\d+$/.test(v)) return v;
                // Otherwise find by name (Text)
                const found = options.find(opt =>
                    String(opt.Text || opt.Value || opt.Name || "").toLowerCase() === v.toLowerCase() ||
                    String(opt.SrcmedCampName || "").toLowerCase() === v.toLowerCase()
                );
                return String(found?.Code || found?.Value || found?.SrcmedCampID || found?.Id || v);
            };

            const sourceId = getMappedId(editForm.Source, sourceOptions);
            const mediumId = getMappedId(editForm.Medium, mediumOptions);
            const campaignId = getMappedId(editForm.Campaign, campaignOptions);

            const selectedCountryName = countries.find(c => String(c.Id) === String(editForm.Country) || String(c.Code) === String(editForm.Country))?.Text || countries.find(c => String(c.Id) === String(editForm.Country) || String(c.Code) === String(editForm.Country))?.Value || "";
            const selectedStateName = statesList.find(s => String(s.Id) === String(editForm.State) || String(s.Code) === String(editForm.State))?.Text || statesList.find(s => String(s.Id) === String(editForm.State) || String(s.Code) === String(editForm.State))?.Value || "";
            const selectedCityName = citiesList.find(c => String(c.Id) === String(editForm.City) || String(c.Code) === String(editForm.City))?.Text || citiesList.find(c => String(c.Id) === String(editForm.City) || String(c.Code) === String(editForm.City))?.Value || "";

            // Construct InsertEnquiryNew_BOLocation structure matching the exact requirement
            const enquiryDetails = {
                EnquiryId: 0,
                PersonName: editForm.PersonName,
                PersonImage: "",
                CompanyName: editForm.Company || "",
                MobileNo1: mobiles[0].number ? `${mobiles[0].dialCode} ${mobiles[0].number}` : "",
                MobileNo2: mobiles[1]?.number ? `${mobiles[1].dialCode} ${mobiles[1].number}` : "",
                MobileNo3: mobiles[2]?.number ? `${mobiles[2].dialCode} ${mobiles[2].number}` : "",
                EmailId1: emails[0] || "",
                EmailId2: emails[1] || "",
                EmailId3: emails[2] || "",
                City: selectedCityName || "",
                State: selectedStateName || "",
                CountryName: selectedCountryName || "",
                CountryCode1: mobiles[0]?.dialCode.replace('+', '') || "",
                CountryCode2: mobiles[1]?.dialCode.replace('+', '') || "",
                CountryCode3: mobiles[2]?.dialCode.replace('+', '') || "",
                ResidentialAddress: editForm.ResiAddress || "",
                Pincode: Number(editForm.PinCode) || 0,
                SourceName: String(sourceId) || "", // Pass ID as SourceName as requested
                Medium: String(mediumId) || "",
                Campaign: String(campaignId) || "",
                InitialRemarks: editForm.Remarks || "",
                ParentId: Number(parentId),
                CreatedBy: Number(userId),
                lstCustomField: lstCustomField,
                Latitude: "0",
                Longitude: "0"
            };

            const payload = {
                Token: "-2295521862261168",
                Details: JSON.stringify(enquiryDetails)
            };

            // Using SaveEnquiryWithLocation endpoint as requested
            const response = await fetch(Save_Enqiury_With_Location, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result.Status === 1) {
                    setAlertConfig({
                        show: true,
                        type: 'success',
                        title: 'Success',
                        message: 'Enquiry Added successfully',
                        onConfirm: () => {
                            if (onSuccess) onSuccess();
                            onBack();
                        }
                    });
                } else {
                    setAlertConfig({
                        show: true,
                        type: 'error',
                        title: 'Validation Failed',
                        message: result.Details || result.Message || 'Failed to add enquiry.'
                    });
                }
            } else {
                setAlertConfig({
                    show: true,
                    type: 'error',
                    title: 'Error',
                    message: 'Failed to connect to server.'
                });
            }
        } catch (error) {
            console.error("Error adding enquiry:", error);
            setAlertConfig({
                show: true,
                type: 'error',
                title: 'Error',
                message: 'An error occurred while saving.'
            });
        } finally {
            setIsSaving(false);
        }
    };

    if (loading) return <div className="add-enquiry-loader"><Loader /></div>;

    return (
        <div className="flex flex-col h-full bg-slate-50 overflow-hidden">
            {/* Drawer Header */}
            <div className="add-enquiry-drawer-header" style={{ padding: '8px 15px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px', borderBottom: '1px solid #ddd', background: '#fff' }}>
                <X size={18} style={{ color: '#0ea5e9', cursor: 'pointer' }} onClick={onBack} />
                <button
                    onClick={onBack}
                    style={{ border: 'none', background: 'none', color: '#16a34a', fontSize: '16px', fontWeight: '500', cursor: 'pointer', padding: 0 }}
                >
                    Back to Enquiry
                </button>
            </div>

            <div className="add-enquiry-drawer-content scrollbar-thin" style={{ background: '#f5f5f5' }}>
                <div className="drawer-inner-container" style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
                    {/* Basic Details Section */}
                    <div className="drawer-section premium-card" style={{ background: '#fff', borderRadius: '4px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
                        <div className="drawer-section-header" style={{ padding: '15px 20px', borderBottom: '1px solid #eee', color: '#666', fontSize: '14px', fontWeight: '600' }}>
                            <span>Basic <span style={{ color: 'red' }}>*</span></span>
                        </div>
                        <div className="drawer-section-body" style={{ padding: '20px' }}>
                            <div className="avatar-flex-container" style={{ display: 'flex', gap: '40px' }}>
                                {/* Left Side: Avatar */}
                                <div className="avatar-upload-column" style={{ width: '180px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div className="avatar-preview-wrapper" style={{ width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', background: '#f0f0f0', border: '1px solid #ddd', position: 'relative' }}>
                                        {profilePreview ? (
                                            <img src={profilePreview} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <User size={50} style={{ color: '#ccc' }} />
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                        <button
                                            className="avatar-link-btn"
                                            onClick={() => avatarInputRef.current.click()}
                                            style={{ color: '#000', fontSize: '12px', border: '1px solid #ccc', padding: '2px 8px', borderRadius: '3px', background: '#fff' }}
                                        >
                                            Choose File
                                        </button>
                                        <span style={{ fontSize: '11px', color: '#666', marginLeft: '5px' }}>
                                            {profileFile ? profileFile.name : 'No file chosen'}
                                        </span>
                                    </div>
                                    <input
                                        type="file"
                                        ref={avatarInputRef}
                                        onChange={handleAvatarChange}
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                    />
                                    <p style={{ marginTop: '8px', fontSize: '11px', color: '#059669', lineHeight: '1.4', textAlign: 'left' }}>
                                        (jpg, png, bmp & gif images max size 1mb)
                                    </p>
                                </div>

                                {/* Right Side: Standard Fields */}
                                <div className="avatar-fields-column" style={{ flex: 1 }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <input
                                            type="text"
                                            placeholder="Name (Required)"
                                            value={editForm.PersonName}
                                            onChange={(e) => setEditForm({ ...editForm, PersonName: e.target.value })}
                                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none' }}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '15px' }}>
                                        {/* Mobile Fields */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {mobiles.map((m, idx) => (
                                                <div key={idx} style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px', padding: '0 10px', background: '#fff' }}>
                                                        <div
                                                            className="dial-code-selector"
                                                            onClick={() => toggleMobileDropdown(idx)}
                                                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', borderRight: '1px solid #eee', paddingRight: '10px', marginRight: '10px' }}
                                                        >
                                                            <img src={m.flag} alt="flag" style={{ width: '20px', height: '14px', marginRight: '5px' }} />
                                                            <span style={{ fontSize: '13px' }}>{m.dialCode}</span>
                                                            <ChevronDown size={12} style={{ marginLeft: '5px', color: '#999' }} />
                                                        </div>
                                                        <input
                                                            type="text"
                                                            placeholder={`Mobile ${idx + 1}${idx === 0 ? ' (Required)' : ''}`}
                                                            value={m.number}
                                                            onChange={(e) => updateMobile(idx, 'number', e.target.value.replace(/\D/g, ''))}
                                                            style={{ border: 'none', outline: 'none', padding: '8px 0', flex: 1, fontSize: '13px' }}
                                                        />
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                            {idx > 0 && (
                                                                <Trash2
                                                                    size={14}
                                                                    onClick={() => removeMobileField(idx)}
                                                                    style={{ color: '#ef4444', cursor: 'pointer', padding: '2px' }}
                                                                />
                                                            )}
                                                            {idx === mobiles.length - 1 && mobiles.length < 3 && (
                                                                <Plus
                                                                    size={16}
                                                                    onClick={addMobileField}
                                                                    style={{ color: '#3b82f6', cursor: 'pointer', background: '#eff6ff', borderRadius: '50%', padding: '2px' }}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Searchable Dial Code Dropdown */}
                                                    {m.showDropdown && (
                                                        <div className="dial-code-dropdown" style={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            zIndex: 1000,
                                                            background: '#fff',
                                                            border: '1px solid #e2e8f0',
                                                            borderRadius: '6px',
                                                            boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
                                                            marginTop: '4px',
                                                            maxHeight: '250px',
                                                            overflowY: 'auto',
                                                            width: '280px'
                                                        }}>
                                                            <div style={{ position: 'sticky', top: 0, background: '#fff', padding: '8px', borderBottom: '1px solid #f1f5f9' }}>
                                                                <div style={{ position: 'relative' }}>
                                                                    <Search size={14} style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Search country..."
                                                                        className="dial-search-input"
                                                                        value={dialSearchTerm}
                                                                        autoFocus
                                                                        style={{ width: '100%', padding: '6px 10px 6px 28px', fontSize: '12px', border: '1px solid #e2e8f0', borderRadius: '4px', outline: 'none' }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(e) => setDialSearchTerm(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {dynamicCountries
                                                                .filter(c =>
                                                                    c.name.toLowerCase().includes(dialSearchTerm.toLowerCase()) ||
                                                                    c.dialCode.includes(dialSearchTerm)
                                                                )
                                                                .map((c, i) => (
                                                                    <div
                                                                        key={i}
                                                                        onClick={() => {
                                                                            updateMobile(idx, 'dialCode', c.dialCode);
                                                                            updateMobile(idx, 'flag', c.flag);
                                                                            toggleMobileDropdown(idx, false);
                                                                            setDialSearchTerm('');
                                                                        }}
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            gap: '10px',
                                                                            padding: '10px 12px',
                                                                            cursor: 'pointer',
                                                                            borderBottom: '1px solid #f8fafc',
                                                                            transition: 'background 0.2s'
                                                                        }}
                                                                        onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                                                                    >
                                                                        <img src={c.flag} alt={c.name} style={{ width: '20px', height: '14px', objectFit: 'cover', borderRadius: '1px' }} />
                                                                        <span style={{ fontSize: '13px', flex: 1, color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</span>
                                                                        <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '600', minWidth: '45px', textAlign: 'right' }}>{c.dialCode}</span>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        {/* Email Fields */}
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {emails.map((email, idx) => (
                                                <div key={idx} style={{ display: 'flex', alignItems: 'center', border: '1px solid #ddd', borderRadius: '4px', padding: '0 10px', background: '#fff' }}>
                                                    <input
                                                        type="email"
                                                        placeholder={`Email ${idx + 1}${idx === 0 ? ' (Required)' : ''}`}
                                                        value={email}
                                                        onChange={(e) => updateEmail(idx, e.target.value)}
                                                        style={{ border: 'none', outline: 'none', padding: '8px 0', flex: 1, fontSize: '13px' }}
                                                    />
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        {idx > 0 && (
                                                            <Trash2
                                                                size={14}
                                                                onClick={() => removeEmailField(idx)}
                                                                style={{ color: '#ef4444', cursor: 'pointer', padding: '2px' }}
                                                            />
                                                        )}
                                                        {idx === emails.length - 1 && emails.length < 3 && (
                                                            <Plus
                                                                size={16}
                                                                onClick={addEmailField}
                                                                style={{ color: '#3b82f6', cursor: 'pointer', background: '#eff6ff', borderRadius: '50%', padding: '2px' }}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '25px' }}>
                                        <select
                                            value={editForm.Source}
                                            onChange={(e) => setEditForm({ ...editForm, Source: e.target.value })}
                                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', outline: 'none', color: '#666', fontSize: '13px', appearance: 'none', background: 'url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' fill=\'none\' stroke=\'%23666\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'M2 4l4 4 4-4\'/%3E%3C/svg%3E") no-repeat right 12px center #fff' }}
                                        >
                                            <option value="">Select Source (Required)</option>
                                            {sourceOptions.map((s, i) => <option key={i} value={(s.Id && s.Id !== 0 && s.Id !== "0") ? s.Id : (s.Code || s.Value || s.SrcmedCampID || s.Id)}>{s.Text || s.Name || s.SrcmedCampName}</option>)}
                                        </select>
                                    </div>

                                    {/* Custom Fields List in Basic Section */}
                                    <div className="custom-fields-list">
                                        {customFieldsList.map((item, idx) => renderCustomField(item, idx))}
                                    </div>

                                    {/* Advance Toggle Link */}
                                    {!isAdvanced && (
                                        <div style={{ marginTop: '20px' }}>
                                            <button
                                                onClick={() => setIsAdvanced(true)}
                                                style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#059669', fontSize: '14px', fontWeight: '600', border: 'none', background: 'none', cursor: 'pointer' }}
                                            >
                                                <Plus size={16} style={{ background: '#059669', color: '#fff', borderRadius: '50%', padding: '2px' }} />
                                                Advance
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {isAdvanced && (
                        <>
                            {/* Enquiry Details Section */}
                            <div className="drawer-section premium-card" style={{ background: '#fff', borderRadius: '4px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
                                <div className="drawer-section-header" style={{ padding: '10px 20px', borderBottom: '1px solid #eee', color: '#333', fontSize: '14px', fontWeight: '600' }}>
                                    <span>Enquiry Details</span>
                                </div>
                                <div className="drawer-section-body" style={{ padding: '20px' }}>
                                    <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                                        <select
                                            value={editForm.Medium}
                                            onChange={(e) => setEditForm({ ...editForm, Medium: e.target.value })}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        >
                                            <option value="">Select Medium</option>
                                            {mediumOptions.map((m, i) => <option key={i} value={(m.Id && m.Id !== 0 && m.Id !== "0") ? m.Id : (m.Code || m.Value || m.SrcmedCampID || m.Id)}>{m.Text || m.Name || m.SrcmedCampName}</option>)}
                                        </select>
                                        <select
                                            value={editForm.Campaign}
                                            onChange={(e) => setEditForm({ ...editForm, Campaign: e.target.value })}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        >
                                            <option value="">Select Campaign</option>
                                            {campaignOptions.map((c, i) => <option key={i} value={(c.Id && c.Id !== 0 && c.Id !== "0") ? c.Id : (c.Code || c.Value || c.SrcmedCampID || c.Id)}>{c.Text || c.Name || c.SrcmedCampName}</option>)}
                                        </select>
                                    </div>
                                    <div>
                                        <textarea
                                            placeholder="Initial Remarks"
                                            rows="2"
                                            value={editForm.Remarks}
                                            onChange={(e) => setEditForm({ ...editForm, Remarks: e.target.value })}
                                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            {/* Enquiry Tags Section */}
                            <div className="drawer-section premium-card" style={{ background: '#fff', borderRadius: '4px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
                                <div className="drawer-section-header" style={{ padding: '10px 20px', borderBottom: '1px solid #eee', color: '#333', fontSize: '14px', fontWeight: '600' }}>
                                    <span>Enquiry Tags</span>
                                </div>
                                <div className="drawer-section-body" style={{ padding: '20px' }}>
                                    <div
                                        className="tag-input-container"
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '5px',
                                            padding: '5px 12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            background: '#fff',
                                            minHeight: '38px',
                                            alignItems: 'center'
                                        }}
                                        onClick={() => tagInputRef.current?.focus()}
                                    >
                                        {(editForm.EnquiryTags ? editForm.EnquiryTags.split(',').filter(t => t.trim()) : []).map((tag, idx) => (
                                            <div
                                                key={idx}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    background: '#f3f4f6',
                                                    border: '1px solid #e5e7eb',
                                                    borderRadius: '3px',
                                                    padding: '2px 6px',
                                                    fontSize: '12px',
                                                    color: '#374151'
                                                }}
                                            >
                                                <span>{tag}</span>
                                                <X
                                                    size={12}
                                                    style={{ cursor: 'pointer', color: '#9ca3af' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const tags = editForm.EnquiryTags.split(',').filter(t => t.trim());
                                                        tags.splice(idx, 1);
                                                        setEditForm({ ...editForm, EnquiryTags: tags.join(',') });
                                                    }}
                                                />
                                            </div>
                                        ))}
                                        <input
                                            ref={tagInputRef}
                                            type="text"
                                            placeholder={(editForm.EnquiryTags || "").length === 0 ? "Search tags" : ""}
                                            value={tagInput}
                                            onChange={(e) => setTagInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
                                                    e.preventDefault();
                                                    const val = tagInput.trim();
                                                    if (val) {
                                                        const currentTags = editForm.EnquiryTags ? editForm.EnquiryTags.split(',').map(t => t.trim()).filter(Boolean) : [];
                                                        if (!currentTags.includes(val)) {
                                                            const newTags = [...currentTags, val].join(',');
                                                            setEditForm({ ...editForm, EnquiryTags: newTags });
                                                        }
                                                        setTagInput('');
                                                    }
                                                } else if (e.key === 'Backspace' && !tagInput && editForm.EnquiryTags) {
                                                    const tags = editForm.EnquiryTags.split(',').filter(t => t.trim());
                                                    tags.pop();
                                                    setEditForm({ ...editForm, EnquiryTags: tags.join(',') });
                                                }
                                            }}
                                            onPaste={(e) => {
                                                e.preventDefault();
                                                const pasteData = e.clipboardData.getData('text');
                                                const pastedTags = pasteData.split(/[,\n]/).map(t => t.trim()).filter(Boolean);
                                                if (pastedTags.length > 0) {
                                                    const currentTags = editForm.EnquiryTags ? editForm.EnquiryTags.split(',').map(t => t.trim()).filter(Boolean) : [];
                                                    const uniquePasted = pastedTags.filter(t => !currentTags.includes(t));
                                                    const newTags = [...currentTags, ...uniquePasted].join(',');
                                                    setEditForm({ ...editForm, EnquiryTags: newTags });
                                                }
                                            }}
                                            style={{
                                                border: 'none',
                                                outline: 'none',
                                                fontSize: '13px',
                                                flex: 1,
                                                minWidth: '100px',
                                                padding: '4px 0'
                                            }}
                                        />
                                    </div>
                                    <p style={{ marginTop: '10px', fontSize: '12px', background: '#ecfdf5', color: '#059669', padding: '8px 12px', borderRadius: '4px', border: '1px solid #d1fae5' }}>
                                        Please press comma, tab, or enter key for generating the tag name, or you can also generate a tag by copy and paste with comma separated value.
                                    </p>
                                </div>
                            </div>

                            {/* Company Details Section */}
                            <div className="drawer-section premium-card" style={{ background: '#fff', borderRadius: '4px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
                                <div className="drawer-section-header" style={{ padding: '10px 20px', borderBottom: '1px solid #eee', color: '#333', fontSize: '14px', fontWeight: '600' }}>
                                    <span>Company Details</span>
                                </div>
                                <div className="drawer-section-body" style={{ padding: '20px' }}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <input
                                            type="text"
                                            placeholder="Company"
                                            value={editForm.Company}
                                            onChange={(e) => setEditForm({ ...editForm, Company: e.target.value })}
                                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                                        <select
                                            value={editForm.Country}
                                            onChange={(e) => handleCountryChange(e.target.value)}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        >
                                            <option value="">Select Country</option>
                                            {countries.map((c, i) => <option key={i} value={(c.Id && c.Id !== 0 && c.Id !== "0") ? c.Id : (c.Code || c.Id)}>{c.Text || c.Value || c.Name}</option>)}
                                        </select>
                                        <select
                                            value={editForm.State}
                                            onChange={(e) => handleStateChange(e.target.value)}
                                            disabled={!editForm.Country}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        >
                                            <option value="">State</option>
                                            {statesList.map((s, i) => <option key={i} value={(s.Id && s.Id !== 0 && s.Id !== "0") ? s.Id : (s.Code || s.Id)}>{s.Text || s.Value || s.Name}</option>)}
                                        </select>
                                    </div>
                                    <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                                        <select
                                            value={editForm.City}
                                            onChange={(e) => setEditForm({ ...editForm, City: e.target.value })}
                                            disabled={!editForm.State}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        >
                                            <option value="">City</option>
                                            {citiesList.map((c, i) => <option key={i} value={(c.Id && c.Id !== 0 && c.Id !== "0") ? c.Id : (c.Code || c.Id)}>{c.Text || c.Value || c.Name}</option>)}
                                        </select>
                                        <input
                                            type="text"
                                            placeholder="Pin Code"
                                            value={editForm.PinCode === '0' ? '' : editForm.PinCode}
                                            onChange={(e) => setEditForm({ ...editForm, PinCode: e.target.value })}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                        <textarea
                                            placeholder="Residential Address"
                                            rows="2"
                                            value={editForm.ResiAddress}
                                            onChange={(e) => setEditForm({ ...editForm, ResiAddress: e.target.value })}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        ></textarea>
                                        <textarea
                                            placeholder="Official Address"
                                            rows="2"
                                            value={editForm.OfficeAddress}
                                            onChange={(e) => setEditForm({ ...editForm, OfficeAddress: e.target.value })}
                                            style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none' }}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            {/* Auto Lead Section */}
                            <div className="drawer-section premium-card" style={{ background: '#fff', borderRadius: '4px', border: '1px solid #e5e7eb', marginBottom: '20px' }}>
                                <div className="drawer-section-header" style={{ padding: '10px 20px', borderBottom: '1px solid #eee', color: '#333', fontSize: '14px', fontWeight: '600' }}>
                                    <span>Auto Lead</span>
                                </div>
                                <div className="drawer-section-body" style={{ padding: '20px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '100px' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                                            <input
                                                type="radio"
                                                checked={addToLead}
                                                onClick={() => setAddToLead(!addToLead)}
                                                onChange={() => { }}
                                                style={{ width: '16px', height: '16px', accentColor: '#059669' }}
                                            />
                                            Add To Lead
                                        </label>

                                        <select
                                            value={selectedUser}
                                            onChange={(e) => setSelectedUser(e.target.value)}
                                            disabled={!addToLead}
                                            style={{ flex: 1, maxWidth: '400px', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', outline: 'none', background: !addToLead ? '#f9fafb' : '#fff' }}
                                        >
                                            <option value="">Select User</option>
                                            {usersList.map((u, i) => {
                                                const val = u.Code || u.Value || u.Id || u.userid || u.UserId;
                                                const text = u.Text || u.Name || u.UserName;
                                                return <option key={i} value={val}>{text}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Back Link */}
                            <div style={{ marginBottom: '20px' }}>
                                <button
                                    onClick={() => setIsAdvanced(false)}
                                    style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#059669', fontSize: '14px', fontWeight: '600', border: 'none', background: 'none', cursor: 'pointer' }}
                                >
                                    <ChevronLeft size={16} style={{ background: '#059669', color: '#fff', borderRadius: '50%', padding: '2px' }} />
                                    Back
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Drawer Footer */}
            <div className="drawer-footer-modern shadow-2xl">
                <button className="drawer-cancel-btn-modern" onClick={onBack}>Cancel</button>
                <button className="drawer-save-btn-modern shadow-lg" onClick={handleSave} disabled={isSaving}>
                    {isSaving ? (
                        <>
                            <div className="spinner-small mr-2" />
                            <span>Saving...</span>
                        </>
                    ) : (
                        <>
                            <Save size={18} />
                            <span>Save Enquiry</span>
                        </>
                    )}
                </button>
            </div>

            {/* Standard Alert Component */}
            <Alert
                show={alertConfig.show}
                type={alertConfig.type}
                title={alertConfig.title}
                message={alertConfig.message}
                onConfirm={() => {
                    if (alertConfig.onConfirm) alertConfig.onConfirm();
                    setAlertConfig({ ...alertConfig, show: false });
                }}
                onCancel={() => setAlertConfig({ ...alertConfig, show: false })}
            />
        </div>
    );
};

export default AddEnquiryForm;
